import { Component, OnInit,  ViewEncapsulation, Inject } from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';
import {MainService} from "../../services/main.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', './mobile.style.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {

	public carouselOne: NgxCarousel;

  mobile:boolean = false;

  constructor(private mService:MainService, breakpointObserver: BreakpointObserver, public dialog: MatDialog) {
    // breakpointObserver.observe([
    //   Breakpoints.HandsetLandscape,
    //   Breakpoints.HandsetPortrait
    // ]).subscribe(result => {
    //   if (result.matches) {
    //     this.mobile = true;
    //   }
    // });
  }

  news:any;
  event:any;
  notice:any;
  realNotice:any;
  nodisplay:boolean = false;


  openDialog(): void {
  //   const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
  //     width: '300px',
  //     data: {name: "V"}
  //   });
  }




  sortNotice(theNotice){
    let sorted = [];
    for (var i of theNotice) {
      sorted.unshift(i);
    }
    this.realNotice = sorted;
  }

  ngOnInit() {

    this.openDialog();
    this.mService.getNewsList().subscribe((result:any)=>{
      this.news = result;
      console.log(this.news);

    });

    this.mService.getEventList().subscribe((result:any)=>{
      this.event = result;
    });

    this.mService.getNoticeList().subscribe((result:any)=>{
      this.notice = result;
    });


    this.mService.getRealNotice().subscribe((r:any)=>{
      this.realNotice = r;
      this.sortNotice(this.realNotice);
      // console.log(r);
    })



  	this.carouselOne = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    }
  }

}



@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
})
export class DialogOverviewExampleDialog {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}


// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts